"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireDefault(require("react")),
    _CreditsInfo = _interopRequireDefault(require("../components/CreditsInfo")),
    _index = require("../../../index");

function CreditsInfoContainer() {
  return _react["default"].createElement(_index.CreditsConsumer, null, function (a) {
    var b = a.state,
        c = b.isUnlimited,
        d = b.creditType,
        e = b.userTeams,
        f = b.creditBalance;
    return _react["default"].createElement(_CreditsInfo["default"], {
      isUnlimited: c,
      creditType: d,
      teams: e,
      creditBalance: f
    });
  });
}

var _default = CreditsInfoContainer;
exports["default"] = _default;